import PAApi from './_paApi.js';
import httpClient from '@/apis/base/httpclient';

class PASortEmployeeAPI extends PAApi {
  constructor() {
    super();
  }
  controllerName = 'PaSortEmployees';

  /**
   * Hàm kiểm lấy dữ liệu cán bộ, phòng ban
   * @param {*} records
   * @returns
   * dqvinh 16.11.2022
   */
  async getSortEmployee() {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/getSortEmployee',
    };

    return await httpClient.getAsync(request);
  }

  /**
   * Hàm lưu sắp xếp cán bộ, phòng ban
   * @returns
   * dqvinh 5.12.2022
   */
  async saveSalarySortOrder(param) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/saveSalarySortOrder',
      data: param,
    };

    return httpClient.postAsync(request, true);
  }
}

export default new PASortEmployeeAPI();
